import { PhoneCall, ClipboardCheck, FileText, CheckCircle2 } from "lucide-react";

const STEPS = [
  {
    icon: PhoneCall,
    title: "Kontakta oss",
    text: "Du ringer, mejlar eller skickar in en offertförfrågan.",
  },
  {
    icon: ClipboardCheck,
    title: "Vi gör en bedömning",
    text: "Vi tittar på platsen, trädet och förutsättningarna för arbetet.",
  },
  {
    icon: FileText,
    title: "Du får en tydlig offert",
    text: "Du får veta vad som ska göras, vad det kostar och hur RUT-avdrag hanteras.",
  },
  {
    icon: CheckCircle2,
    title: "Vi utför arbetet tryggt",
    text: "Vi kommer överens om tid och utför arbetet säkert, effektivt och enligt plan.",
  },
];

export default function ProcessSection() {
  return (
    <section
      data-testid="process-section"
      className="section-pad bg-[#EFEBDF]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12 lg:mb-16">
          <span className="eyebrow">Så går det till</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1B2A1E] leading-tight">
            Tydlig process — från första kontakt till färdigt arbete
          </h2>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <li
                key={step.title}
                data-testid={`process-step-${i + 1}`}
                className="tf-reveal relative bg-white border border-[#E2E0D8] rounded-xl p-6 lg:p-7 flex flex-col"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-md bg-[#1B2A1E] text-white">
                    <Icon className="w-5 h-5" strokeWidth={2.2} />
                  </span>
                  <span className="font-heading text-4xl font-extrabold text-[#D95D2E]/20 tabular-nums">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg text-[#1B2A1E] mb-2">
                  {step.title}
                </h3>
                <p className="text-[15px] text-[#3a4338] leading-relaxed">
                  {step.text}
                </p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
